<style scoped>
    .suggestions-showing {
        border-right: 1px solid lightgrey
    }
</style>
<template>
    <div>
        <br />
        <div class="row">
            <div :class="{'col-md-9' : showSuggestions, 'col-md-12' : !showSuggestions, 'suggestions-showing' : showSuggestions}">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.Title"></forminput>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.FirstName"></forminput>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.MiddleName"></forminput>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.LastName"></forminput>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12">

                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <datepicker :controller="controller.Dob" :end-date="today" start-date="01/01/1900" ></datepicker>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.NhsId"></forminput>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <formselect v-bind:controller="controller.Sex" v-bind:options="sexOptions"></formselect>
                    </div>
                    <!--<div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.Mobile"></forminput>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.Email"></forminput>
                    </div>-->
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <br />
                    <div class="well well-sm">
                        Address
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <forminput :controller="controller.addressLine"></forminput>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <forminput :controller="controller.PostCode"></forminput>
                    </div>
                </div>
            </div>
            <!--<div class="col-md-3" v-if="showSuggestions">
                <div class="text-center">Suggestions</div>
                <table class="table" style="margin:10px">
                    <tbody>
                        <tr v-for="(sug,index) in controller.Suggestions" style="cursor:pointer" @click="selectPatient(sug)">
                            <td><strong style="margin-right:10px; vertical-align:top">#{{index}}</strong></td>
                            <td>
                                <strong style="margin-right:10px">
                                    <small class='text-primary'>{{sug.title}}</small>
                                    {{sug.firstName}} {{sug.lastName }}
                                </strong>
                                <small class="text-info">{{formatDate(sug.dob)}}</small>
                                <small class="text-muted" style="display:block">
                                    <em>
                                        {{getAddress(sug)}}
                                    </em>
                                </small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>-->
        </div>
        <div class="row">
            <br /><br />
            <div class="col-md-12">
                <div class="col-md-12" v-if="controller">
                    <a class="btn btn-primary" v-if="!controller.hasError" @click="SavePatient" :disabled="this.isWorking">
                    <i v-if="this.isWorking" class="fa fa-refresh fa-spin"></i> Save</a>
                    <a class="btn btn-warning" @click="Reset"  :disabled="this.isWorking">Reset</a>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
    import forminput from '../../corecontrols/forminput/forminput.scp.html'
    import formselect from '../../corecontrols/formselect/formselect.scp.html'
    import datepicker from '../../corecontrols/datepicker/datepicker.scp.html'
    import moment from 'moment'
    import Formatter from "../../corecontrols/formatters/Formatter";

    import SimpleDatePicker from "../../corecontrols/simpledatepicker/simpledatepicker.scp.html";
    import { NewPatientFormController } from './NewPatientFormController'
import { FmdCode } from '../../../dto/FMD/Models';
import FmdDal from '../../../scripts/FmdDal';
    export default {
        props: ['value', 'patientid'],
        data: function () {
            return {
                isWorking : false,
                controller: {},
                patient: null,
                fmdDal: {},
                today : new Date(),
                startDate : moment(new Date()).subtract(120, 'year').toDate(),
                sexOptions: ["Male", "Female", "Unspecified"]
            }
        },
        created() {
            this.fmdDal = new FmdDal(this.$root.CurrentUnitId);
            this.controller = new NewPatientFormController(this.$root.CurrentUnitId)
        },
        mounted() {
            if (this.patientid) {
                this.fmdDal.GetPatient(this.patientid).then(p => {
                    console.log("Editing PAtient ", p)
                    this.controller.Initialize(p);
                    
                })
            }
        },
        computed: {
            showSuggestions() {
                return false;
                //return this.controller && this.controller.Suggestions && this.controller.Suggestions.length > 0
            }
        },
        methods: {
            Reset() {
                this.controller.Reset()
            },
            SavePatient() {
                
                if (this.controller.validate()) {
                    this.isWorking = true;
                    var dto = this.controller.GetDto();
                    console.log(dto)
                    setTimeout(() => {
                        this.fmdDal.SavePatient(dto).then(p => {
                            this.controller = new NewPatientFormController(this.$root.CurrentUnitId, this.$root.UiSession)
                            this.selectPatient(p);
                            this.isWorking = false;
                        })
                    }, 1000);
                }
            },
            formatDate(dt) {
                return Formatter.FormatDate(dt);
            },
            getAddress(pt) {
                if (!pt)
                    return "";

                return pt.line1
                    +
                    (pt.line2 ? (", " + pt.line2) : "") +
                    (pt.line3 ? (", " + pt.line3) : "") +
                    (pt.town ? (", " + pt.town) : "") +
                    (pt.postCode ? ", " + pt.postCode : "")
            },
            selectPatient(pt) {
                this.patient = pt
                this.$emit('input', pt);
            }
        },
        components: {
            forminput,
            datepicker,
            SimpleDatePicker,
            formselect
        }
    }
</script>


// WEBPACK FOOTER //
// NewPatientForm.scp.html?e4139fcc